export function getMost<T>(obj: { [key: string]: T }, predicate: (val: T) => number) {
  return Object.keys(obj).reduce<number | undefined>((curr, key) => {
    const result = predicate(obj[key]);
    if (!curr || result > curr) return result;
    return curr;
  }, undefined);
}
